import { getFirestore } from "firebase/firestore"
import { getAuth } from "firebase/auth"
import { initializeApp } from "firebase/app"
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage"
import { getAnalytics, isSupported } from "firebase/analytics"

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
}

const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
const auth = getAuth(app)
// const analytics = getAnalytics(app)

// Check if Analytics is supported in the current environment
isSupported().then((supported) => {
  if (supported) {
    const analytics = getAnalytics(app)
  } else {
    console.log("Firebase Analytics is not supported in this environment")
  }
})
//***** STORAGE********** */
const storage = getStorage(app)

function createRef(path) {
  return ref(storage, path)
}

function uploadFile(ref, file) {
  return uploadBytesResumable(ref, file)
}

async function getDownloadUrl() {
  // TODO: Replace the following with your file path in Firebase Storage
  const filePath = "coursesImages/Udemy thumbnail 18_5.2.4.jpg"

  const fileRef = ref(storage, filePath)

  try {
    const url = await getDownloadURL(fileRef)
  } catch (error) {
    console.error(error)
  }
}

// Call the function to get the download URL
getDownloadUrl()
const videoVitor = ref(
  storage,
  "gs://inglesautodidata-5b0b9.appspot.com/studentsTestemonies/vitorTestemony.mp4"
)
const videoRaissa = ref(
  storage,
  "gs://inglesautodidata-5b0b9.appspot.com/studentsTestemonies/raissaTestemony.mp4"
)
const videoIntroKids = ref(
  storage,
  "gs://inglesautodidata-5b0b9.appspot.com/introductionVideos/full-kids-intro-ad2.mp4"
)
const videoShortFlashcards = ref(
  storage,
  "gs://inglesautodidata-5b0b9.appspot.com/introductionVideos/flashcards-short-vid.mp4"
)
const videoShortReading = ref(
  storage,
  "gs://inglesautodidata-5b0b9.appspot.com/introductionVideos/reading-short-vid.mp4"
)
const videoShortSpeaking = ref(
  storage,
  "gs://inglesautodidata-5b0b9.appspot.com/introductionVideos/speakingPractice-short-vid.mp4"
)
const videoShortPtExplanation = ref(
  storage,
  "gs://inglesautodidata-5b0b9.appspot.com/introductionVideos/grammar-explanation-portuguese.mp4"
)
const videoShortEnExplanation = ref(
  storage,
  "gs://inglesautodidata-5b0b9.appspot.com/introductionVideos/explanation-english-short.mp4"
)
const videoShortExercises = ref(
  storage,
  "gs://inglesautodidata-5b0b9.appspot.com/introductionVideos/exercises-short-vid.mp4"
)
const videoShortPronunciation = ref(
  storage,
  "gs://inglesautodidata-5b0b9.appspot.com/introductionVideos/pronunciation-short.mp4"
)
const videoShortListening = ref(
  storage,
  "gs://inglesautodidata-5b0b9.appspot.com/introductionVideos/listening-short-vid.mp4"
)
const landscapeMethodologyContact = ref(
  storage,
  "gs://inglesautodidata-5b0b9.appspot.com/introductionVideos/landscape-methodology-contact.mp4"
)
const landingPageAd = ref(
  storage,
  "gs://inglesautodidata-5b0b9.appspot.com/introductionVideos/landingPageAd.mp4"
)

export {
  db,
  auth,
  app,
  storage,
  createRef,
  uploadFile,
  videoVitor,
  videoRaissa,
  videoIntroKids,
  landingPageAd,
  videoShortFlashcards,
  videoShortReading,
  videoShortListening,
  videoShortExercises,
  videoShortPronunciation,
  videoShortSpeaking,
  videoShortPtExplanation,
  videoShortEnExplanation,
}
